import {isNil} from 'ramda';

import {useQueryState} from 'shared/web';

/**
 * Reads `?sort=` from the URL and returns it as orderBy fields.
 * Example: `?sort=last_occurrence` → `['last_occurrence']`.
 * Comma-separated values are supported: `?sort=last_occurrence,-price`.
 * Testing escape hatch — invalid fields fail on the backend (table error only).
 */
export function useSortOrderByFromUrl(): {
  orderBy: string[] | null;
  clear: () => void;
} {
  const [sortParam, , clear] = useQueryState('sort');

  if (isNil(sortParam) || sortParam === '') {
    return {orderBy: null, clear};
  }

  const fields = sortParam.split(',').filter((part) => part.length > 0);
  return {orderBy: fields.length > 0 ? fields : null, clear};
}
